import Vue from 'vue'
import {ToggleButton} from 'vue-js-toggle-button'
import LoadingComponent from '@/components/partials/LoadingComponent'
import CustomInput from '@/components/partials/CustomInput'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import vSelect from 'vue-select'
import NoData from '@/components/partials/NoData'
import PbTable from '@/components/partials/PbTable'

Vue.component('vs-select', vSelect)
Vue.component('ToggleButton', ToggleButton)
Vue.component('loading-component', LoadingComponent)
Vue.component('PulseLoader', PulseLoader)
Vue.component('CustomInput', CustomInput)
Vue.component('NoData', NoData)
Vue.component('PbTable', PbTable)



// WEBPACK FOOTER //
// ./src/helpers/cmp/index.js